module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flight"
  }, [_c('div', {
    staticClass: "destination"
  }, [_vm._v("\n    " + _vm._s(_vm.flight.destination.city) + "\n    "), _c('div', {
    staticClass: "toggles"
  }, [_c('div', {
    staticClass: "more-3",
    on: {
      "click": function($event) {
        _vm.flight.details = !_vm.flight.details
      }
    }
  }, [(_vm.flight.details) ? _c('i', {
    staticClass: "fa fa-toggle-on"
  }) : _vm._e(), _vm._v(" "), (!_vm.flight.details) ? _c('i', {
    staticClass: "fa fa-toggle-off"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-2"
  }, [_vm._v("Show More Flight Details")])]), _vm._v(" "), _c('div', {
    staticClass: "more-3",
    on: {
      "click": function($event) {
        _vm.flight.attractions = !_vm.flight.attractions
      }
    }
  }, [(_vm.flight.attractions) ? _c('i', {
    staticClass: "fa fa-toggle-on"
  }) : _vm._e(), _vm._v(" "), (!_vm.flight.attractions) ? _c('i', {
    staticClass: "fa fa-toggle-off"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-2"
  }, [_vm._v("Show Destination Attractions")])])])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "length"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Length")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v(_vm._s(_vm.flight.trip.duration) + " days")]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("Round trip")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "leave"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Leaving")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.flight.trip.leave))]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "more-details"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.flight.origin.airport) + "\n          "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v("\n          " + _vm._s(_vm.flight.destination.airport) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n        Direct flight\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.flight.airline) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "return"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Returning")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.flight.trip.return))]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "more-details"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.flight.destination.airport) + "\n          "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v("\n          " + _vm._s(_vm.flight.origin.airport) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n        Direct flight\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.flight.airline) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "data"
  }, [_vm._v("$" + _vm._s(_vm.flight.price))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.flight.attractions) ? _c('div', {
    staticClass: "attractions"
  }, [_c('ul', _vm._l((_vm.attractionsList), function(attraction) {
    return _c('li', [_c('div', {
      staticClass: "attraction"
    }, [_c('label', [_vm._v(_vm._s(attraction.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": attraction.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(attraction.description))])])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "act"
  }, [_c('a', {
    staticClass: "book",
    attrs: {
      "href": "/#/book"
    }
  }, [_vm._v("\n        Get this ticket\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b520b1d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flight.vue
// module id = 72
// module chunks = 1